export const getAccessList = (payload?: any) => ({
    type: "@saga/GET_ACCESS_LIST",
    payload
});